var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-height-0"},[_c('div',{staticClass:"wave-footer-bottom-img foreground",class:this.backgroundCustom})])
}
var staticRenderFns = []

export { render, staticRenderFns }